const DASH = {
  SET_INVOICES_QUERY: 'SET_INVOICES_QUERY',
};

export default DASH;
